import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allMonth,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import { ThemeProvider } from "@material-ui/core";
import { editStocktakeCancel } from "./stocktakeSlice";

export const ModalCancel = ({ isOpen, handleShow, setShow, id, name }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClose = () => setShow(false);

  const [copy, setCopy] = useState("");

  const handleSave = async () => {
    const params = {
      stocktake_id: id,
      stocktake_status: "5412",
    };
    try {
      const response = await dispatch(editStocktakeCancel(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Cancel Job Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <p>
              You are about to cancel the job plan No. {name}, this task cannot
              be undone!
              <br />
              Are you sure want to cancel this job plan?
            </p>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
